const getTimezones = () => {
  return Intl.supportedValuesOf("timeZone").sort();
};

export default getTimezones;
